module.exports = __webpack_public_path__ + "static/media/favicon-par-perfeito.3659d7d3.ico";